import React from "react";
import DataAccessHelper from "../Helper/DataAccessHelper.js";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import '../Styles/AccountDetails.scss';


function AccountDetails({ registrationInfo, setViewAccountDetailsVisibility }) {
   console.log("queried registration", registrationInfo)
   const [accountInfo, setAccountInfo] = useState({})

   async function GetAccountInformation() {
      const response = await fetch('/getaccountinformation', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
            accountId: registrationInfo.account_id
         })
      })
      const accountInfo = await response.json();
      console.log("account Info", accountInfo.data.account[0])
      setAccountInfo(accountInfo.data.account[0])
   }

 useEffect(() => {
         GetAccountInformation()
   }, []);


   return(
      <div className="AccountDetailsContainer">
         <div className="AccountDetailsContent">
            <div className="AccountDetailsHeading">
               Accountholder Details
            </div>
            <div className="AccountDetailsFields">
               <div className="AccountDetailsName">
                  Name: {accountInfo.first_name + " " + accountInfo.last_name}
               </div>
               <div className="AccountDetailsGender">
                  Gender: {accountInfo.gender}
               </div>
               <div className="AccountDetailsDateOfBirth">
                  Date of Birth: {DateHelpers.getDisplayDate(accountInfo.birth_date)}
               </div>
               <div className="AccountDetailsAddressOne">
                  Address Line One: {accountInfo.address_line_one}
               </div>   
               <div className="AccountDetailsAddressTwo">
                  Address Line Two: {accountInfo.address_line_two}
               </div>
               <div className="AccountDetailsCity" >
                  City: {accountInfo.city}
               </div>
               <div className="AccountDetailsState">
                  State: {accountInfo.state}
               </div>
               <div className="AccountDetailsZip">
                  Zip: {accountInfo.zip}
               </div>
               <div className="AccountDetailsCountry">
                  Country: {accountInfo.country}
               </div>
               <div className="AccountDetailsPhone">
                  Phone: {accountInfo.phone_number}
               </div>
               <div className="AccountDetailsEmail">
                  Email: {accountInfo.email_address}
               </div>
            </div>
            <div className="AccountDetailsCloseButtonContainer">
               <button onClick={() => setViewAccountDetailsVisibility(false)}>
                  Close
               </button>
            </div>
         </div>
      </div>
   )
}
export default AccountDetails